import { useMemo } from 'react';
import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { LegStatus } from '@api/Trinium/types';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';
import { getEnumValueByKey } from '@/Infrastructure/Utilities';

/**
 * Initiate Street Turn Action
 */
export default function StreetTurnAction() {
	const gridApiRef = useGridApiContext();
	const appDispatch = useAppDispatch();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const leg = useMemo(() => {
		const legId = selectedRowIds.keys().next().value;
		return legId ? gridApiRef.current.getRow<DispatchLeg>(legId) : undefined;
	}, [gridApiRef, selectedRowIds]);

	// This action requires exactly 1 row to be selected, be First ECL Leg of Export type and not have status of PU/DL
	if (
		selectedRowIds.size !== 1 ||
		!leg ||
		!leg.isFirstECL ||
		leg.jobCategoryTransportationType !== 'Export' ||
		[LegStatus.PU, LegStatus.DL].includes(getEnumValueByKey(LegStatus, leg.legStatus) as LegStatus)
	) {
		return <></>;
	}

	const handleBtnClick = () => {
		appDispatch(
			queueModal({
				Component: 'streetTurnModal',
				Props: {
					legId: leg.legId
				}
			})
		);
	};

	return <ListItemButton onClick={handleBtnClick}>Initiate a Street Turn</ListItemButton>;
}
